module.exports = __webpack_public_path__ + "static/media/marcelo.3a1317b4.jpg";